import React from "react";
import { useRouter } from "next/router";
import { redirectBackUrl } from "utils/method";
import getCommonStaticProps from "@xt/ssg";
import Layout from "components/Layout";
import LayoutAuth from "components/Layout/Auth";
import Login from "components/Pages/Login";
import Seo from "components/Seo";

export default function PageLogin({ locale, tdk, resolvedUrl }) {
  const router = useRouter();

  const onAuthError = () => {
    redirectBackUrl(router);
  };

  return (
    <>
      <Seo tdk={tdk} resolvedUrl={resolvedUrl} locale={locale} />
      <Layout>
        <LayoutAuth needLogin={false} onAuthError={onAuthError}>
          <Login />
        </LayoutAuth>
      </Layout>
    </>
  );
}

export const getStaticProps = (context) => getCommonStaticProps(context, "/accounts/login", { zE_show: true });
